<template>
    <LayoutBlock
        :tutorial_dialog="tutorial_dialog"
        v-on:closeDialog="handleCloseDialog"
        >
            <div class="d-flex flex-column" v-if="measures">
            <div class="pl-2 pb-2 subtitle-1" v-if="conf.title" >{{conf.title}}</div>
            <v-container class="ma-0 pa-0">
                <v-row no-gutters>
                    <v-col cols="6">
                    <!-- componente a parte ha flag obbligatorio -->
                    <v-radio-group class="pa-0 ma-0" disabled v-model="measures.zero_device" label="Mantenimento dello zero">
                        <v-radio label="Attivo" value="on"></v-radio>
                        <v-radio label="Disattivo" value="off"></v-radio>
                        <v-radio label="Fuori zona intervento" value="out"></v-radio>
                    </v-radio-group>
                    </v-col>
                    <v-col cols="6">
                    <!-- componente a parte ha flag obbligatorio e meccanico-->
                    <v-radio-group class="pa-0 ma-0" :disabled="preview" v-model="measures.hi_res" label="Alta risoluzione">
                        <v-radio label="Attivo" value="on"></v-radio>
                        <v-radio label="Disattivo" value="off"></v-radio>
                    </v-radio-group>
                </v-col>
                </v-row>
                <v-row no-gutters>
                    <i class="subtitle-1 my-2">Punti di appoggio: <b>{{measures.points}}</b></i>
                </v-row>
                <v-row no-gutters>

                <v-col cols="6" class="pa-1">
                    <NumericField dense outlined
                        class="pa-0 ma-0"
                        label="valore iniziale"
                        v-model="measures.zero_val"
                        @input="changeMass"
                        :readonly="preview"
                        :suffix="data.instrument_data.uom"
                    ></NumericField>
                </v-col>
                <v-col cols="6" class="pa-1">
                    <NumericField dense outlined
                        class="pa-0 ma-0"
                        label="valore nominale"
                        v-model="measures.mass"
                        @input="changeMass"
                        :readonly="preview"
                        :suffix="data.instrument_data.uom"
                        :precision="currentPrecision"
                    ></NumericField>
                        <!--@blur="handleBlur(measures, 'mass')"-->
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12">
                    <v-img max-width="400" max-height="200" :src="image_data" />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12" class="d-flex justify-end py-2" v-if="!preview">
                    <v-btn @click="convertPlaceholders(measures.items)" color="primary">Riempimento automatico</v-btn>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-simple-table class="measure_table">
                <template v-slot:default>
                    <thead class="expansion">
                    <tr>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.pos}}</th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.mass}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.reading}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right" v-if="measures.hi_res == 'off'">{{data.block.conf.headers.addLoad}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right" v-if="measures.hi_res == 'off'">{{data.block.conf.headers.p}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.error}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.error_corr}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.mpe}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.result}}</th>
                    </tr>
                    </thead>
                    <tr v-for="(item,index) of measures.items" :key="index">
                    <td class="table-blocks d-flex align-center">
                        <v-icon class="d-flex flex-shrink-1 flex-grow-0" v-if="index > measures.points && !preview" @click="removeRow(index)">delete</v-icon>
                        <div v-else class="d-flex pr-4"></div>
                        <div class="d-flex justify-center flex-shrink-0 flex-grow-1 pr-1">{{item.position}}</div>
                    </td>
                    <td class="table-blocks" v-if="index == 0">
                        <NumericField dense outlined 
                            hide-details 
                            disabled 
                            v-model="item.mass"
                            :precision="currentPrecision"
                            />
                    </td>
                    <td class="table-blocks" v-if="index == 1" :rowspan="measures.items.length">
                        <NumericField dense outlined
                            hide-details  
                            v-model="item.mass" 
                            disabled
                            :precision="currentPrecision"
                            />
                    </td>
                    <td class="table-blocks">
                        <NumericField dense outlined 
                        solo hide-details 
                        :placeholder="readingPlaceholder(item.mass)"
                        v-model="item.reading" 
                        :readonly="preview"  
                        :class="readingWarning(item.reading)"
                        @input="changeReading(item)"
                        :precision="currentPrecision"
                        :enableicons="!preview"
                        :addfunc="readingAddFunc"
                        :subfunc="readingSubFunc"
                        :row="item"
                        :fieldname="'reading'"
                        :range="calcMinRange(item.reading)"
                        />
                    </td>
                    <td class="table-blocks"  v-if="measures.hi_res == 'off'">
                        <NumericField dense outlined 
                            @input="changeAddLoad(item)" 
                            :placeholder="calculateAddLoadPlaceholder(item.reading)" 
                            solo hide-details
                            :readonly="preview" 
                            v-model="item.addLoad"
                            :precision="high_precision"
                            :class="addLoadWarning(item.addLoad, item.reading)"
                            :enableicons="!preview"
                            :addfunc="loadAddFunc"
                            :subfunc="loadSubFunc"
                            :row="item"
                            :fieldname="'addLoad'"
                            :range="calcMinRange(item.reading)"
                        />
                    </td>
                    <td class="text-right table-text-blocks" v-if="measures.hi_res == 'off'">
                        <b class="table-blocks">{{item.p | formatNumber}}</b></td>
                    <td class="text-right table-text-blocks"><b>{{item.error | formatNumber}}</b></td>
                    <td class="text-right table-text-blocks"><b>{{item.error_corr | formatNumber}}</b></td>
                    <td class="text-right table-text-blocks"><b>{{item.mpe | formatNumber}}</b></td>
                    <td class="table-text-blocks text-right">
                        <StatusIcon 
                            :status="item.result"
                            :tooltip_text="row_tooltip[item.result]" />
                    </td>
                </tr>
                </template>                    
                </v-simple-table>
            </v-row>
            <v-row no-gutters>
                <div class="d-flex flex-column flex-grow-1 flex-shrink-0 table-bordered ma-2">
                    <div v-if="precision_overflow" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Controlla valori e precisione letture</b></div>
                    <div v-if="addLoad_overflow" class="error--text caption"><StatusIcon status="failed" small/><b>Controlla carico addizionale</b></div>
                </div>        
                <div class="d-flex flex-grow-0 flex-shrink-1 my-2">
                    <v-btn v-if="checkStatic && !preview" color="primary" @click="addRow"><v-icon class="pa-2">add_box</v-icon>aggiungi misura</v-btn>
                </div>
            </v-row>
            </v-container>
        </div>
    </LayoutBlock>
</template>

<script>

import {eccentricity_item} from "../../../utils/itemBlockSchema"
import {BaseIsoSimple} from "../../../utils/baseIsoSimple"
import LayoutBlock from "../../../components/utils/LayoutBlock"
import StatusIcon from "../../../components/utils/StatusIcon"
import Big from "big.js"

export default {
    components: {LayoutBlock, StatusIcon},    
    mixins: [BaseIsoSimple],

    data(){
        return{
            initial_item: eccentricity_item ({
                position: '',
                error_corr: '~',
                result: 'uncomplete'
                }),
        }
    },

    methods: {
        async buildMeasures(){
            this.measures = {
                items: [],
                shape: null,
                zero_device: this.conf.zero_device,
                hi_res: this.conf.hi_res,
                zero_val: 0,
                mass: 0,
                mpe_zero: 0,
                mpe_mass: 0,
                points: 0,
                result: 'uncomplete'
            }
            this.measures.points = this.calcMeasures()
            await this.getImageID()
            await this.getImage()
            if(this.data.instrument_data != null){
                let currentRange = this.instrument_data.ranges[0]
                this.measures.zero_val = this.instrument_data.instrument_class ? Big(currentRange.e).times(10).toString() : Big(currentRange.d).times(10).toString() 
                let catMass = await this.buildWithCategory()
                this.measures.mass = catMass ? catMass : this.round(0)
                this.measures.mpe_zero = this.calculate_MPE(currentRange, this.measures.zero_val) 
                this.measures.mpe_mass = this.calculate_MPE(currentRange, this.measures.mpe_mass)
            }
            this.measures.items.push(this.initial_item)
            for (let i = 1; i<= this.measures.points; i++){
                this.addRow()
            }
            this.changeMass()
            console.log("DEBUG: new measures", this.measures)
        },
        addRow(){
            let item = eccentricity_item({
                position: this.measures.items.length,
            })
            this.measures.items.push(item)
        },
        changeMass(){
            if(this.measures.mass){
                console.log("changed mass")
                let zero = Big(this.measures.zero_val)
                let temp = zero.plus(this.measures.mass).toString()
                let currRange = this.calcMinRange(temp)
                let mpe = this.calculate_MPE(currRange, temp)
                for(let i=1;i<this.measures.items.length;i++){
                    this.measures.items[i].mass = temp
                    this.measures.items[i].mpe = mpe
                }
                if(this.measures.items && this.measures.items.length > 0){
                    this.measures.items[0].mass = this.round(zero)
                    this.measures.items[0].mpe = this.calculate_MPE(currRange, zero.toString())
                }
                this.measures.mpe = mpe
            }
        },
        calcError(row){
            if(this.measures.hi_res == 'on'){
                row.error = this.differenceInt(row.reading, row.mass)
                this.calculateResult(row)
            } else {
                if (row.addLoad != null && row.addLoad != ""){
                    row.error = this.differenceInt(row.p, row.mass)
                    if(this.checkLoad(row.addLoad, row.mass)){
                        this.calculateResult(row)
                    } else {
                        row.result = "failed"
                    }
                } else {
                    row.result = "uncomplete"
                }

            }
        },
        calcDiff(){
            let start_error = null
            for(let i=0; i<this.measures.items.length;i++){
                let row = this.measures.items[i]
                this.calcError(row)
                if(i == 0){
                    start_error = row.error
                } else {
                    row.error_corr = this.differenceInt(row.error, start_error)
                }
            }
        },
        
        
    },
    



}
</script>

